import React from 'react';
import { VideoboxProps } from '../types/typedeclaration';
 import { activetabslice } from '../store/navigationSlice';
  import { useAppDispatch } from '../store/hooks';
import { Link } from 'react-router-dom';
export const Videobox: React.FC<VideoboxProps> = ({
  darkMode,
  fontSize, 
  inlineView,
  videos
}) => { 
   const dispatch = useAppDispatch(); 
    const [loading, setLoading] = React.useState(false)

    const setActiveTab = (val:string) => { 
      dispatch(activetabslice(val))
    }
  return (
    <div className={`${inlineView ? ('z-20'):('fixed inset-0')} pb-4 ${darkMode ? 'bg-gray-900' : 'bg-gray-100'}`}>

        {loading ? ("Loading..."):(<><div className="container mx-auto px-4x pt-0">

             {!inlineView && (<div className="flex items-center justify-end mb-4">
              <button 
                onClick={() => setActiveTab('home')}
                className={`px-3 py-1 text-xs rounded !rounded-button ${
                  fontSize === 'small' 
                    ? darkMode ? 'bg-orange-500 text-white' : 'bg-orange-500 text-white' 
                    : darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                }`}
              >
                close x
              </button>
            </div>)}              

          </div>
          <div className={`container mx-auto py-0 ${inlineView && ('px-4x')}`}>
            {/* <h2 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-800'}`}>Videos</h2> */}
            
            <div className={`grid gap-4 ${!inlineView && ('overflow-y-scroll max-h-[calc(100vh-150px)]')}`}>
              {/* Featured Video */}
              {videos && Array.isArray(videos) && videos?.length > 0 && (
                videos.slice(0,1).map((video)=> {                
                  return (<div key={video?.id} className={`rounded-lg overflow-hidden shadow-lg ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                <div className="relative">
                  <Link id={video?.post_slug} to={`/news/${video?.post_slug}`}>
                  <img 
                    src={video?.post_featured_image} 
                    alt="Featured Video" 
                    className="w-full h-48 object-cover"
                  /></Link>
                  {/* <div className="absolute inset-0 flex items-center justify-center">                   
                    <div className="bg-black bg-opacity-50 rounded-full p-4">
                      <i className="fas fa-play text-white text-2xl"></i>
                      view 
                    </div>                   
                  </div> */}
                  {/* <div className="absolute bottom-0 right-0 bg-red-600 text-white px-2 py-1 text-xs">
                    {video?.location} 
                  </div> */}
                </div>
                <div className="p-3">
                  <Link id={video?.post_slug} to={`/news/${video?.post_slug}`}>
                  <h3 className={`font-bold mb-1 ${
                    fontSize === 'small' ? 'text-base' : 
                    fontSize === 'large' ? 'text-xl' : 'text-lg'
                  }`}>
                    {video?.post_title}
                  </h3></Link>
                  {/* <p className={`${
                    darkMode ? 'text-gray-300' : 'text-gray-600'
                  } mb-2 ${
                    fontSize === 'small' ? 'text-xs' : 
                    fontSize === 'large' ? 'text-base' : 'text-sm'
                  }`}>
                    description
                  </p> */}
                  <div className="flex justify-between items-center">
                    <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                      <i className="far fa-clock mr-1"></i> {video?.created}
                    </span>
                    <span className={`text-xs px-2 py-1 rounded ${
                      darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                    }`}>
                     {video?.location}
                    </span>
                  </div>
                </div>
              </div>)
                })
              )}
              
              
              {/* Video List */}
              {Array.isArray(videos) && videos?.length > 1 &&  videos?.slice(1).map((video) => (
                <div key={video?.id} className={`rounded-lg overflow-hidden shadow-md ${
                  darkMode ? 'bg-gray-800' : 'bg-white'
                } flex`}>
                  <div className="w-2/5 relative">
                   <Link id={video?.post_slug} to={`/news/${video?.post_slug}`}>
                    <img 
                      src={video?.post_featured_image_thumb} 
                      alt={video?.post_title} 
                      className="w-full h-full object-cover"
                    /></Link>
                    {/* <div className="absolute bottom-1 right-1 bg-black bg-opacity-70 text-white px-1 text-xs">
                      {video?.location}
                    </div> */}
                  </div>
                  <div className="w-3/5 p-2">
                  <Link id={video?.post_slug} to={`/news/${video?.post_slug}`}>
                    <h3 className={`font-medium ${
                      fontSize === 'small' ? 'text-sm' : 
                      fontSize === 'large' ? 'text-lg' : 'text-base'
                    } line-clamp-2`}>
                      {video?.post_title}
                    </h3></Link>
                    <div className="flex justify-between items-center mt-2">
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        {video?.location}
                      </span>
                      {/* <span className={`text-xs px-1 py-0.5 rounded ${
                        darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                      }`}>
                        {video.views}
                      </span> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div></>)}
        

          

          

        </div>
  )
}
